"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const queryDefinitions_1 = require("queryDefinitions");
const tokenHeader_1 = require("tokenHeader");
const SimpleTable_1 = require("components/Dashboard/SimpleTable");
const DeveloperUI_1 = __importDefault(require("./DeveloperUI"));
const ApiKey = {
    Publishable: 'publishable',
    Secret: 'secret'
};
const Developer = () => {
    const [keys, setKeys] = (0, react_1.useState)([]);
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'loading' does not exist on type '((optio... Remove this comment to see the full error message
    const [getApiKeys, { loading, error, data }] = (0, tokenHeader_1.useAuthedLazyQuery)(queryDefinitions_1.GET_API_KEYS);
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'data' does not exist on type '((graphqlV... Remove this comment to see the full error message
    const [createApiKey, { data: createApiKeyData, error: createApiKeyError }] = (0, tokenHeader_1.useAuthedMutationWithAccountId)(queryDefinitions_1.CREATE_API_KEY);
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'error' does not exist on type '((graphql... Remove this comment to see the full error message
    const [deleteApiKey, { error: deleteApiKeyError }] = (0, tokenHeader_1.useAuthedMutationWithAccountId)(queryDefinitions_1.DELETE_API_KEY);
    const [publicApiKeys, setPublicApiKeys] = (0, react_1.useState)([]);
    const [secretApiKeys, setSecretApiKeys] = (0, react_1.useState)([]);
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '() => Promise<void>' is not assi... Remove this comment to see the full error message
    (0, react_1.useEffect)(() => __awaiter(void 0, void 0, void 0, function* () {
        // @ts-expect-error ts-migrate(2349) FIXME: This expression is not callable.
        getApiKeys();
    }), []);
    (0, react_1.useEffect)(() => {
        if (data) {
            setKeys(data.standardKeys.edges.map((edge) => edge.node));
        }
    }, [data]);
    (0, react_1.useEffect)(() => {
        const publishableKeys = keys.filter(
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'type' does not exist on type 'never'.
        (record) => record.type === ApiKey.Publishable);
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'type' does not exist on type 'never'.
        const secretKeys = keys.filter((record) => record.type === ApiKey.Secret);
        setPublicApiKeys(publishableKeys);
        setSecretApiKeys(secretKeys);
    }, [keys]);
    (0, react_1.useEffect)(() => {
        if (createApiKeyData) {
            // @ts-expect-error ts-migrate(2322) FIXME: Type 'any' is not assignable to type 'never'.
            setKeys([...keys, createApiKeyData.createStandardKey.standardKey]);
        }
    }, [createApiKeyData]);
    function handleDelete(row) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { deleteStandardKey: { ok } }
            // @ts-expect-error ts-migrate(2349) FIXME: This expression is not callable.
             } = yield deleteApiKey({
                id: row.id
            });
            if (ok) {
                // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'any[]' is not assignable to para... Remove this comment to see the full error message
                setKeys((0, SimpleTable_1.removeEntryFromSimpleTable)(keys, row));
            }
            return Promise.resolve();
        });
    }
    function handleCreate(args) {
        // @ts-expect-error ts-migrate(2349) FIXME: This expression is not callable.
        createApiKey({
            name: args.name,
            type: args.type.toUpperCase()
        });
    }
    const computedError = error || createApiKeyError || deleteApiKeyError;
    return (react_1.default.createElement(DeveloperUI_1.default, { handleCreate: handleCreate, handleDelete: handleDelete, hasError: !!computedError, loading: loading, publicApiKeys: publicApiKeys, secretApiKeys: secretApiKeys }));
};
exports.default = Developer;
